// "Overall Sentiment by Question" table with per-question sentiment breakdown and pagination.

import React from "react";
import { Typography } from "@material-tailwind/react";
import InfoDialog from "components/dialog/info-dialog";
import Pagination from "components/pagination";
import Trademark from "components/Trademark";
import {
    GobbyTable,
    GobbyTableHead,
    GobbyTableBody,
    GobbyTableRow,
    GobbyTableHeader,
    GobbyTableCell,
} from "components/ui/gobby-table";

export function SentimentByQuestionSection({
    questionTotalSentimentData,
    questionTotalSentimentPage,
    setQuestionTotalSentimentPage,
}) {
    return (
        <div>
            <div className="flex justify-between flex-wrap">
                <Typography
                    variant="h4"
                    className="ml-2 text-black"
                >
                    Overall Sentiment by Question
                </Typography>
                <InfoDialog title="Reading Overall Sentiment Scores">
                    <Typography
                        as="span"
                        className="font-body text-black"
                    >
                        Each response to a Gobby
                        <Trademark /> style question has a sentiment
                        percentage score applied to it e.g., a response
                        might score as: &lsquo;Positive&rsquo; 89.29%&rdquo; The highest
                        sentiment percentage score for each response is
                        tallied, by question, and shown in the table.
                        The highlighted figures are the highest number
                        of responses applied to a sentiment, by
                        question.
                    </Typography>
                </InfoDialog>
            </div>
            <div className="p-2 mb-2">
                <div className="p-2 rounded-lg bg-white mt-2 w-full">
                    {!!questionTotalSentimentData?.data && (
                        <>
                            <GobbyTable>
                                <GobbyTableHead className="text-sm sm:text-lg">
                                    <GobbyTableRow className="pt-2">
                                        <GobbyTableHeader className="font-body w-1/12">
                                            Position
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body w-7/12">
                                            Text
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Mixed
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Positive
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Negative
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Neutral
                                        </GobbyTableHeader>
                                    </GobbyTableRow>
                                </GobbyTableHead>
                                <GobbyTableBody className="text-black text-right">
                                    {questionTotalSentimentData?.data
                                        ?.sort(
                                            (a, b) =>
                                                a.position -
                                                b.position,
                                        )
                                        .map((question) => (
                                            <GobbyTableRow
                                                key={
                                                    question.question_id
                                                }
                                            >
                                                <GobbyTableCell className="font-body text-center">
                                                    {
                                                        question.position
                                                    }
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-left font-body">
                                                    {question.text}
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-center">
                                                    <span
                                                        className={`text-center font-body px-4 ${
                                                            question
                                                                .respondent_sentiment
                                                                .highest ===
                                                            question
                                                                .respondent_sentiment
                                                                .mixed
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {
                                                            question
                                                                .respondent_sentiment
                                                                .mixed
                                                        }
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-center">
                                                    <span
                                                        className={`font-body px-4 ${
                                                            question
                                                                .respondent_sentiment
                                                                .highest ===
                                                            question
                                                                .respondent_sentiment
                                                                .positive
                                                                ? "font-bold bg-ornage-400 rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {
                                                            question
                                                                .respondent_sentiment
                                                                .positive
                                                        }
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-center">
                                                    <span
                                                        className={`font-body px-4 ${
                                                            question
                                                                .respondent_sentiment
                                                                .highest ===
                                                            question
                                                                .respondent_sentiment
                                                                .negative
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {
                                                            question
                                                                .respondent_sentiment
                                                                .negative
                                                        }
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-center">
                                                    <span
                                                        className={`font-body px-4 ${
                                                            question
                                                                .respondent_sentiment
                                                                .highest ===
                                                            question
                                                                .respondent_sentiment
                                                                .neutral
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {
                                                            question
                                                                .respondent_sentiment
                                                                .neutral
                                                        }
                                                    </span>
                                                </GobbyTableCell>
                                            </GobbyTableRow>
                                        ))}
                                </GobbyTableBody>
                            </GobbyTable>
                            <Pagination
                                currentPage={
                                    questionTotalSentimentData?.pager
                                        ?.current_page ||
                                    questionTotalSentimentPage
                                }
                                lastPage={
                                    questionTotalSentimentData?.pager
                                        ?.last_page
                                }
                                onPageChange={setQuestionTotalSentimentPage}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
